import React from 'react';
import { Button, Card } from './ui';

const HIPAAWarningModal = ({ isOpen, onClose, onAccept, userName, userRole }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="mx-4 w-full max-w-2xl">
        <Card className="border-2 border-red-500">
          <div className="flex items-start gap-4">
            <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-red-100">
              <svg className="h-6 w-6 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
              </svg>
            </div>
            <div className="flex-1">
              <h3 className="text-xl font-display font-semibold text-neutral-900">
                HIPAA Privacy & Confidentiality Notice
              </h3>
              <div className="mt-4 space-y-3 text-sm text-neutral-700">
                <p>
                  <strong>Protected Health Information (PHI) Access Warning</strong>
                </p>
                <p>
                  You are about to access private journal entries belonging to <strong>{userName}</strong>. 
                  This information is protected under the Health Insurance Portability and Accountability Act (HIPAA) 
                  and must be treated with the highest level of confidentiality.
                </p>
                
                <div className="rounded-md bg-red-50 p-3 border border-red-200">
                  <p className="font-medium text-red-800">By proceeding, you acknowledge:</p>
                  <ul className="mt-2 ml-4 space-y-1 list-disc text-red-700">
                    <li>You are accessing this information for legitimate clinical/administrative purposes only</li>
                    <li>You will maintain strict confidentiality of all information viewed</li>
                    <li>You will not share, copy, or transmit this information without proper authorization</li>
                    <li>Unauthorized access or disclosure may result in civil and criminal penalties</li>
                    <li>All access is logged and subject to audit</li>
                  </ul>
                </div>

                <p className="text-xs text-neutral-600 italic">
                  Note: The user may have marked certain entries as private. Private entries will not be displayed 
                  {userRole === 'clinician' ? ' unless the user has granted you explicit permission to view their journal' : ''}.
                </p>
              </div>

              <div className="mt-6 flex gap-3 justify-end">
                <Button
                  onClick={onClose}
                  variant="ghost"
                >
                  Cancel
                </Button>
                <Button
                  onClick={onAccept}
                  variant="primary"
                  className="bg-red-600 hover:bg-red-700"
                >
                  I Understand - Proceed
                </Button>
              </div>
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default HIPAAWarningModal;
